import axios from "axios";
import { base_url } from "../../utils/baseUrl";
import { config } from "../../utils/axiosconfig";




const getInvestmentOpportunitys = async () => {
  const UserString = localStorage.getItem("user");
  const User = JSON.parse(UserString);
  const id = User.id;
  const response = await axios.get(`${base_url}ppp/${id}/investment-opportunities`);

  return response.data;

};
const createInvestmentOpportunitys = async (formData) => {
  const UserString = localStorage.getItem("user");
  const User = JSON.parse(UserString);
  const id = User.id;
  const response = await axios.post(`${base_url}ppp/${id}/addInvestmentOpportunity`, formData);

  return response.data;
};
const updateInvestmentOpportunity = async (News) => {
  const UserString = localStorage.getItem("user");
  const User = JSON.parse(UserString);
  const id = User.id;
  const formData = new FormData();
  formData.append("opportunityName", News.NewsData.get("opportunityName"));
  formData.append("opportunityDetails", News.NewsData.get("opportunityDetails"));

  const response = await axios.put(
    `${base_url}ppp/${id}/investment-opportunities/${News.id}`,
    formData,
    config
  );

  return response.data;
};

const getInvestmentOpportunity = async (idd) => {
  const UserString = localStorage.getItem("user");
  const User = JSON.parse(UserString);
  const id = User.id;
  const response = await axios.get(`${base_url}ppp/${id}/investment-opportunities/${idd}`, config);

  return response.data;
};

const deleteInvestmentOpportunity = async (idd) => {
  const UserString = localStorage.getItem("user");
  const User = JSON.parse(UserString);
  const id = User.id;
  const response = await axios.delete(`${base_url}ppp/${id}/investment-opportunities/${idd}`, config);

  return response.data;
};
const InvestmentOpportunityService = {
  getInvestmentOpportunitys,
  createInvestmentOpportunitys,
  getInvestmentOpportunity,
  updateInvestmentOpportunity,
  deleteInvestmentOpportunity,
};

export default InvestmentOpportunityService;
